import { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Check, X } from 'react-feather';
import FileUploadDisplay from '../../components/FileUploadDisplay';
import { toast } from 'react-toastify';

const AdditionalDocument = ({
	onFileSelect,
	initialFile,
	uploadLabel,
	uploadSubtext,
	disabled,
	maxSize = 2 * 1024 * 1024,
	accept = { 'application/pdf': [] },
}) => {
	const [files, setFiles] = useState([]);
	const [documentUrl, setDocumentUrl] = useState(null);

	// Load initial file when component mounts or initialFile changes
	useEffect(() => {
		if (initialFile) {
			// If initialFile is a File object, use it directly
			if (initialFile instanceof File) {
				setFiles([initialFile]);
				setDocumentUrl(null);
			}
			// If initialFile is a string (S3 URL), set it as document URL
			else if (typeof initialFile === 'string') {
				setDocumentUrl(initialFile);
				setFiles([]);
			}
			// If initialFile is an object with file data
			else if (initialFile && typeof initialFile === 'object') {
				if (initialFile.url) {
					setDocumentUrl(initialFile.url);
					setFiles([]);
				} else if (initialFile.data) {
					const file = new File([initialFile.data], initialFile.name || 'additional_document.pdf', {
						type: 'application/pdf',
					});
					setFiles([file]);
					setDocumentUrl(null);
				}
			}
		} else {
			setFiles([]);
			setDocumentUrl(null);
		}
	}, [initialFile]);

	const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		accept,
		maxFiles: 1,
		maxSize,
		disabled: disabled,
		onDrop: (acceptedFiles, fileRejections) => {
			if (acceptedFiles.length > 0) {
				setFiles(acceptedFiles);
				setDocumentUrl(null); // Clear any existing URL when new file is uploaded
				onFileSelect(acceptedFiles[0]);
			}
		},
	});
	const handleRemoveFile = () => {
		setFiles([]);
		onFileSelect(null);
		setDocumentUrl(null);
		toast.info('File removed');
	};
	
	console.log('initialFile',initialFile)
	
	// Check if we have any file to display (either File object or URL)
	const hasFile = files.length > 0 || documentUrl;
	
	return (
		<>
			<div className="dropzone">
				<div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
					<input {...getInputProps()} />
					<div className="dropzone-inner-wrapper">
						{isDragAccept && (
							<div>
								<div className="d-100 btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white">
									<Check className="d-50" />
								</div>
								<div className="font-size-sm text-success">PDF file accepted!</div>
							</div>
						)}
						{isDragReject && (
							<div>
								<div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white">
									<X className="d-60" />
								</div>
								<div className="font-size-sm text-danger">Only PDF files up to 2 MB are allowed!</div>
							</div>
						)}
						{!isDragActive && (
							<div className="upload_detail text-center">
								<img src="/assets/images/upload.svg" alt="Upload" />
								<h4>{uploadLabel || 'Upload Document'}</h4>
								<h5>
									{uploadSubtext || 'please upload your recommendation letter in PDF format with a maximum size of 2MB'}
								</h5>
							</div>
						)}
					</div>
				</div>
			</div>
			
			{/* Show FileUploadDisplay for both URL and File objects */}
			{hasFile && (
				<div className="mt-3">
					<FileUploadDisplay
						file={documentUrl || files[0]}
						onRemove={disabled ? null : handleRemoveFile}
						showDownload={true}
						showView={true}
						showRemove={!disabled}
					/>
				</div>
			)}
		</>
	);
};

export default AdditionalDocument;
